/* unplugin-vue-components disabled */import script from "./CouponTimingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponTimingDetails.vue?vue&type=script&setup=true&lang=js"

import "./CouponTimingDetails.vue?vue&type=style&index=0&id=5b8e6026&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8e6026"]])

export default __exports__